<template>
  <transition name="fade-message">
    <div
      v-if="active"
      class="notification"
      :class="type"
      tabindex="-1"
    >
      <svgicon
        v-if="closeable"
        name="Controls/Close"
        :aria-label="'Stäng notis'"
        class="notification__close"
        @click="close"
      />
      <div
        class="notification__container"
        :class="{ 'msg-only': !title && !linkText }"
      >
        <svgicon
          :name="icon"
          class="notification__type-icon"
          @click="close"
        />
        <div class="notification__container-inner">
          <span
            v-if="title"
            class="notification__title"
          >{{ title }} </span>
          <span class="notification__text">{{ message }} </span>
          <a
            v-if="url"
            :href="url"
            class="notification__url"
          >
            {{ linkText }}
          </a>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import svgicon from 'vue-svgicon'
import '#/Controls/Close'
import '#/Controls/Check'
import '#/Alerts/Warning'
import '#/Alerts/Info'
export default {
  name: 'LegacyNotification',
  components: {
    svgicon
  },
  model: {
    prop: 'active',
    event: 'openstate'
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    closeable: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: '',
      required: true
    },
    url: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'Info',
      required: true
    },
    linkText: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  },
  computed: {
    icon () {
      let i = this.type
      if (i === 'Error') {
        return 'Alerts/Warning'
      } else if (i === 'Success') {
        return 'Controls/Check'
      } else return 'Alerts/Info'
    }
  },
  methods: {
    close () {
      this.$emit('openstate', false)
    }
  }
}
</script>

<style lang="scss">
.notification {
  background-color: $color-orange-lightest;
  border: 1px solid $color-red-light;
  padding: 1rem;
  position: relative;
  border-radius: 0.25rem;

  &.Success {
    background-color: $color-green-lightest;
    border: 1px solid $color-green-light;
  }

  &.Info {
    background-color: $color-purple-lightest;
    border: 1px solid $color-purple-light;
  }

  &__container {
    display: flex;
    max-width: 95%;

    &.msg-only {
      align-items: center;
    }
  }

  &__container-inner {
    display: flex;
    flex-direction: column;
    margin-left: 0.5rem;
  }

  &__title {
    color: $color-red;

    @include font(text, 2, bold);

    .notification.Success & {
      color: $color-green-dark;
    }

    .notification.Info & {
      color: $color-purple-dark;
    }
  }

  &__text {
    color: $color-red;

    @include font(text, 2, normal);

    .notification.Success & {
      color: $color-green-dark;
    }

    .notification.Info & {
      color: $color-purple-dark;
    }
  }

  &__url {
    color: $color-secondary-cta-text;
    margin-top: 0.25rem;

    @include font(text, 2, bold);
  }

  &__close {
    position: absolute;
    right: 4px;
    top: 4px;
    cursor: pointer;
  }

  &__type-icon,
  &__close {
    width: 1.5rem;
    height: 1.5rem;
    min-width: 1.5rem;
    min-height: 1.5rem;
    fill: $color-red;

    .notification.Success & {
      fill: $color-green-dark;
    }

    .notification.Info & {
      fill: $color-purple-dark;
    }
  }
}

.fade-message-enter-active,
.fade-message-leave-active {
  transition: 0.1s ease-in-out, top 1s ease;

  .notification {
    transition: transform 0.3s cubic-bezier(0.2, 0, 0.37, 1.38);
  }
}

.fade-message-leave-active {
  transition-delay: 0.05s;
  transition-duration: 0.15s;
}

.fade-message-enter,
.fade-message-leave-to {
  opacity: 0;

  .notification {
    transform: scale(0.75) translateY(25%);
  }
}

.fade-message-enter-to,
.fade-message-leave {
  opacity: 1;

  .notification {
    transform: scale(1) translateY(0);
  }
}
</style>
